import clsx from "clsx";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  button: {
    color: "white",
    "border-radius": 5,
    padding: [5, 20],
    "font-size": 14,
    border: "none",
    cursor: props => (props.disabled ? "not-allowed" : "pointer"),
    "background-color": props => (props.disabled ? "#ccc" : "#252525"),
    transition: "background-color 0.1s ease",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
});

const Button = ({ disabled = false, className, ...props }) => {
  const classes = useStyles({ disabled });

  return (
    <button
      className={clsx(classes.button, className)}
      disabled={disabled}
      {...props}
    />
  );
};

export default Button;
